import { Component, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { DirtyComponent } from '@app/common/dirty-component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-investor-intel-esg-investment',
  templateUrl: './investor-intel-esg-investment.component.html'
})
export class InvestorIntelEsgInvestmentComponent implements OnInit, DirtyComponent {

  isChild = true; // it is used in the landing component to determine childs
  isEdit = false;
  investorId: number;

  public isDirty = new BehaviorSubject<boolean>(false);
  public isDirty$ = this.isDirty.asObservable();

  constructor(
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.isDirty$.subscribe(data => {
      return of(data);
    });

    this.route.params.subscribe((params) => {
      this.investorId = +params['id'];
    });
  }
}
